import React from 'react';

import TypeOptionsModal from '../TypeOptionsModal';

import {
  createTicketType,
  listTicketTypes,
  updateTicketType,
  deleteTicketType,
} from '../../services/api';


function TicketTypeManagementModal({ open, onClose, }) {
  async function onFetch() {
    const { data, } = await listTicketTypes();
    return (data || [])
      .map((item) => {
        return {
          ...item,
          name: item.type,
        };
      });
  }

  async function onDelete(ticketTypeId) {
    await deleteTicketType(ticketTypeId);
  }

  async function onUpdate({ id, name, }) {
    const { data, } = await updateTicketType(id, name);
    return {
      ...data,
      name: data.type,
    };
  }

  async function onCreate(ticketTypeData) {
    const { data, } = createTicketType(ticketTypeData.name);
    return {
      ...data,
      name: data.type,
    };
  }


  return (
    <TypeOptionsModal
      open={open}
      title="Natureza de chamados"
      onFetch={onFetch}
      onDelete={onDelete}
      onUpdate={onUpdate}
      onCreate={onCreate}
      onClose={onClose}
    />
  );
}

export default TicketTypeManagementModal;
